import { createFileRoute, redirect } from '@tanstack/react-router';

import { getTeamRecommendationIntroductionOptions } from 'client/@tanstack/react-query.gen';

export const Route = createFileRoute(
  '/_private/_route/teams/$teamId/introductions/$candidateId/',
)({
  beforeLoad: async ({ context, params }) => {
    const { queryClient } = context;
    const pIntroduction = queryClient.ensureQueryData(
      getTeamRecommendationIntroductionOptions({
        path: {
          candidate_uuid: params.candidateId,
          team_slug: params.teamId,
        },
      }),
    );
    const [introduction] = await Promise.all([pIntroduction]);
    throw redirect({
      params: {
        recommendationId: introduction.uuid,
        teamId: params.teamId,
      },
      replace: true,
      // Email links arrive as /introductions/<candidate>/?dialog=introduction-request;
      // keep the search so the intro dialog opens on the recommendation page.
      search: true,
      to: '/teams/$teamId/trending/$recommendationId',
    });
  },
});
